<template>
    <div
        id="identify-layer-select"
        class="form-group city-form-group input-group"
    >
        <!-- --{{ currentIndex }}--{{optionValue}}--{{ options }} -->
        <MaterialSelect
            :disabled="disabledSelector"
            class="city-form-group city-bg"
            id="input-layer-index"
            name="layer-index"
            @input="onChangeIndex"
            :noWrap="false"
            :clearable="false"
            :filterable="true"
            :options="options"
            :value="optionValue"
            :initialData="optionInitialData"
            v-validate="'required'"
            :inputClasses="[{ 'is-invalid': fnHasError('layer-index') }]"
            :error="fnFirstError('layer-index')"
        >
            {{ layerPlaceholder }}
        </MaterialSelect>
        <div class="input-group-append"></div>
    </div>
</template>

<script>
import GlobalMixin from "@/app/shared/mixins/global";

export default {
    name: "IdentifyLayerSelector",
    mixins: [GlobalMixin],
    components: {},
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        responses: {
            type: Array,
            default: () => []
        },
        layers: {
            type: Array
        },
        layerPlaceholder: {
            type: String,
            default: "Camada"
        },
        index: {
            type: Number,
            default: 0
        },
        missingResponses: {
            type: Number,
            default: 0
        },
        emptyResponses: {
            type: Boolean,
            default: false
        },
        validator: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            currentIndex: null
        };
    },
    mounted() {
        this.currentIndex = this.index;
    },
    computed: {
        optionInitialData() {
           return this.options.length ? this.options[this.currentIndex] : null;
        },
        optionValue() {
            return this.options.length ? this.options[this.currentIndex]?.id : null;
        },
        options() {
            return this.responses.map((opt, idx) => {
                const value = opt && opt.layerMetadata ? opt.layerMetadata.title : "---";
                return {
                    id:`${idx}-${Math.random().toString(36).substr(2, 9)}`,
                    label: value,
                    valid: !!(this.validator ? this.validator.getValidResponses([opt]).length : 0)
                };
            });
            // .filter(opt => opt.valid);
        },
        disabledSelector() {
            return this.disabled || this.missingResponses !== 0 || this.responses.length === 0 || this.emptyResponses || this.options.length === 0;
        }
    },
    methods: {
        setActiveIndexByLabel(label) {
            let idx = this.options.findIndex(o => o.label == label);
            if (idx > -1 && idx != this.currentIndex) {
                this.currentIndex = idx;
                this.fireChange(idx);
            }
        },
        onChangeIndex(id, evt) {
            let idx = this.options.findIndex(o => o.id == id) ?? 0;
            this.fireChange(idx, true);
        },
        fireChange(idx, reset = false) {
            this.$emit("onChangeIndex", { idx, reset: reset });
        }
    },
    watch: {
        index: {
            immediate: false,
            handler(value, oldVal) {
                this.currentIndex = value;
            }
        }
    }
};
</script>

<style scoped lang="scss"></style>
